import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType } from 'components/list/DynamicListFilterUtils';

import { REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author Burak Ak
 */

export const DriverSummaryConfig = {
	id: DYNAMICLISTS.OTO_FLEX_DRIVER_SUMMARY_REPORT,
	columns: [
		{ Header: 'driverID', accessor: 'driverID', filterType: FilterType.number, width: 70 },
		{
			Header: 'driverName',
			accessor: 'driverName',
			filterType: FilterType.multiSelection,
			width: 100,
			showOnMobile: true
		},
		{
			Header: 'avgPickupTime',
			accessor: 'avgPickupTime',
			filterType: FilterType.string,
			width: 100
		},
		{
			Header: 'avgDeliveryTime',
			accessor: 'avgDeliveryTime',
			filterType: FilterType.string,
			width: 100
		},
		{ Header: 'col.processingCount', accessor: 'processingCount', filterType: FilterType.number, width: 100 },
		{ Header: 'col.deliveredCount', accessor: 'deliveredCount', filterType: FilterType.number, width: 100 },
		{
			Header: 'col.returnedCount',
			accessor: 'returnedCount',
			filterType: FilterType.number,
			width: 100
		},
		{
			Header: 'col.total',
			accessor: 'total',
			filterType: FilterType.number,
			width: 100
		}
	],
	fetchUrl: REPORT.LIST.GET_DRIVER_SUMMARY_LIST,
	exportName: 'driverSummaryReport'
};

const DriverSummary = () => {
	const { state } = useLocation();

	const defaultFilters = useMemo(() => {
		if (!state?.data || Object.keys(state?.data)?.length === 0) {
			return [];
		}

		return [
			{
				column: {
					Header: 'orderDate',
					accessor: 'createdAt',
					filterType: FilterType.date,
					filterRemovable: false,
					customFilterOptions: [FilterAction.between, FilterAction.on]
				},
				action: FilterAction.between,
				value: state.data.date
			}
		];
	}, []);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="driverSummaryReport"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.OTOFLEX_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList {...DriverSummaryConfig} defaultFilters={defaultFilters} />
		</div>
	);
};

export default DriverSummary;
